import { render, staticRenderFns } from "./AcordeonInfo.vue?vue&type=template&id=44df3a95"
import script from "./AcordeonInfo.vue?vue&type=script&lang=js"
export * from "./AcordeonInfo.vue?vue&type=script&lang=js"
import style0 from "./AcordeonInfo.vue?vue&type=style&index=0&id=44df3a95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports